import Vue from "vue/dist/vue.common";
import $ from "jquery";
import anime from "animejs/lib/anime.js";
import Component, { nextTick, subscribe } from "../../js/lib/component";
import Page from "../page/page";
import ProductItem from "../product-item/product-item.vue";
import store from "../../js/Store";

const classList = {
  root: ".js-minicart",
  overlay: ".js-minicart-overlay",
  box: ".js-minicart-box",
  item: ".js-minicart-item",
  close: ".js-minicart-close"
};

export default class MiniCart extends Component {
  init() {
    const scope = this;

    new Vue({
      name: "MiniCart",
      el: this.$.root.get(0),
      computed: {
        cost() {
          return store.getters.cost;
        },
        amount() {
          if (store.getters.amount === 0) {
            nextTick(400).then(() => {
              scope.close();
            });
          }

          return store.getters.amount;
        },
        products() {
          return store.getters.products;
        }
      },
      store,
      components: {
        "product-item": ProductItem
      },
      mounted() {
        scope.$.root = $(this.$el);
        scope.elements();
      }
    });
  }
  events() {
    subscribe("minicart:open", () => this.open());
    subscribe("page:esc", () => this.close());
    this.$.overlay.on("click", () => this.close());
    this.$.close.on("click", () => this.close());
  }
  open() {
    if (this.get("opened")) return;

    const page = this.$.page.get();
    const root = this.$.root.get();
    const overlay = this.$.overlay.get();
    const box = this.$.box.get();
    const item = this.$.item.get();

    anime.set(root, { display: "block" });
    anime.set(overlay, { opacity: 0 });
    anime.set(box, { translateX: "100%" });
    anime.set(item, { translateY: "20px", opacity: 0 });

    Page.bodyOverflowEnable();

    Promise.all([
      anime({
        targets: page,
        easing: "easeOutCubic",
        duration: 450,
        translateX: -30
      }).finished,
      anime({
        targets: overlay,
        easing: "easeOutCubic",
        duration: 450,
        opacity: 0.6
      }).finished,
      anime({
        targets: box,
        easing: "easeOutCubic",
        duration: 450,
        translateX: 0
      }).finished
    ]).then(() => {
      anime({
        targets: item,
        easing: "easeOutCubic",
        duration: 300,
        delay: anime.stagger(80),
        opacity: 1,
        translateY: 0,
        complete: () => {
          this.$.root.hide().show(0); // redraw DOM
          this.set({ opened: true });
        }
      });
    });
  }
  close() {
    if (!this.get("opened")) return;

    const page = this.$.page.get();
    const root = this.$.root.get();
    const overlay = this.$.overlay.get();
    const box = this.$.box.get();

    Promise.all([
      anime({
        targets: page,
        easing: "easeOutCubic",
        duration: 450,
        translateX: 0
      }).finished,
      anime({
        targets: overlay,
        easing: "easeOutCubic",
        duration: 450,
        opacity: 0
      }).finished,
      anime({
        targets: box,
        easing: "easeOutCubic",
        duration: 450,
        translateX: "100%"
      }).finished
    ]).then(() => {
      anime.set(root, {
        display: "none"
      });

      Page.bodyOverflowDisable();

      this.$.page.removeAttr("style");
      this.set({ opened: false });
    });
  }
}

Component.mount(MiniCart, {
  name: "MiniCart",
  classList,
  state: {
    opened: false
  }
});
